import { render, staticRenderFns } from "./ViewSubmission.vue?vue&type=template&id=4080d662&scoped=true&"
import script from "./ViewSubmission.vue?vue&type=script&lang=js&"
export * from "./ViewSubmission.vue?vue&type=script&lang=js&"
import style0 from "./ViewSubmission.vue?vue&type=style&index=0&id=4080d662&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4080d662",
  null
  
)

export default component.exports